module.exports = __webpack_public_path__ + "img/2000_YR_2022_Email-bottom.883f8a24.png";